import React, { FC, useEffect, useState } from "react";
import { Col, Row, Spin } from "antd";
import { useNavigate } from "react-router-dom";

import { appInsights, reactPlugin, withAITracking } from "../../../appInsights";

import DiseasBasedRisk from "./diseas-based-risk";
import HealthMeasure from "./health-measures";
import UtilizationMeasures from "./utilization-measures";
import membersService from "@services/members.service";
import { routeMap } from "@utils/constants";
import memberDetailsService from "@services/memberDetails.service";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { getClientName } from "@utils/helpers";
import Icon from "@assets/icon_config";

interface IChartData {
  x: any;
  y: number;
  legend: any;
}

const RiskScore: FC<any> = (props) => {

  const defaultExpandedCards:any = ["25"];
  const expandAllCards = ["25", "26", "27"];

  const [loadingForRisk, setRiskLoaderFlag] = useState(false);
  const [riskScoreData, setRiskScoreData] = useState<any>({});
  const [activePanels, setActivePanels] = useState<any>(defaultExpandedCards);
  const [chartData, setChartData] = useState<IChartData[]>([])

  const navigate  = useNavigate();
  const clientName = getClientName()
  const membersServiceGetCurrentMember = membersService?.getCurrentMember;
  const patientId = membersService?.getCurrentMember?.patient_id;

  useEffect(() => {
    console.log("RiskScore.useEffect1");
    appInsights.trackPageView({name:"Risk Score"});
  },[]);

  useEffect(() => {
    console.log("RiskScore.useEffect2");
    const getRiskScore = (id: number) => {
      console.log("RiskScore.getRiskScore");
      setRiskLoaderFlag(true);
      memberDetailsService.getRiskScore(id).subscribe({
        next: (v) => {
          console.log(v);
          setRiskLoaderFlag(false);
          setRiskScoreData(v.data.data.RiskScore)
          setRiskChartData(v.data.data.RiskScore.healthMeasures)
        },
        error: (e) => {
          console.log(e);
          setRiskLoaderFlag(false);
          setRiskScoreData({})
  
        },
      });
    };
    const cMember = membersServiceGetCurrentMember;
    if(cMember && cMember?.patient_id)
    {
      let pId = parseInt(cMember?.patient_id);
      getRiskScore(pId);
    }
    else 
      navigate(routeMap["members"])
}, [patientId, navigate]);

  

  const setRiskChartData = (healthMeasures:any) =>{
    const finalArray: IChartData[]  = []
    const severtyOverTime =healthMeasures.chart?.severtyOverTime
    // const a2cSeries = severtyOverTime?.map((item:any) => ({x: item.year_month, y: item.a2c_risk_pct, legend: "A2C Score"}));
    const hccSeries = severtyOverTime?.map((item:any) => ({x: item.year_month, y: item.hcc_risk_val, legend: "HCC Score YTD"}));
    // const sdohSeries = severtyOverTime?.map((item:any) => ({x: item.year_month, y: item.sdoh_risk_pct, legend: "SDoH Score"}));
    // const sdohA2CSeries = severtyOverTime?.map((item:any) => ({x: item.year_month, y: item.sdoh_a2c_risk_pct, legend: "SDoH + A2C Score"}));
    setChartData(finalArray.concat(/*a2cSeries,*/ hccSeries /*, sdohSeries, sdohA2CSeries */));
  }

  const changeCollapse = () => {
    if(activePanels?.length > 0) {
      setActivePanels([])
    } else {
      setActivePanels(expandAllCards)
    }
  }

  useEffect(() => {
    setActivePanels(defaultExpandedCards);
  },[patientId])


  return (
    <Spin spinning={loadingForRisk} indicator={<HealthemSpinner size={70} />}>
      <div>
        <div className="member-detail-tab-header">
          <div className="member-detail-tab-header__collapse-all-button" onClick={changeCollapse}>
            <span className="member-detail-tab-header__collapse-all-button__title">{activePanels?.length > 0 ? "Collapse All" : "Expand All"} </span>
            <span className={`member-detail-tab-header__collapse-all-button__arrow ${activePanels?.length > 0 ? "" : "arrow-down"}`}>
              <Icon name={`${activePanels?.length > 0 ? "arrowUp" : "arrowDown"}`} colorOfBrand={"#0072E3"} />
            </span>
          </div>
        </div>
        <Row>
          <Col span={24}>
            <HealthMeasure data={riskScoreData?.healthMeasures} chartData={chartData} pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels}/>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <UtilizationMeasures data={riskScoreData?.utilizationMeasures} pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels}/>
          </Col>
        </Row>

        {clientName !== "Millennium" && (
          <Row>
            <Col span={24}>
              <DiseasBasedRisk data={riskScoreData?.diseaseBasedRisk} pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels}/>
            </Col>
          </Row>
        )}
      </div>
    </Spin>
  );
};

export default withAITracking(reactPlugin, RiskScore);
